export default __webpack_public_path__ + "static/media/bdx-merignac.e339ac6a.webp";